import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useComponentsTranslations } from "features/components/lib/i18n";
import { getUserByLogin } from "shared/lib/utils/suggest-staff-api";
import { LinearProgress } from "shared/ui/linear-progress/linear-progress";
import styles from "./counter_author.module.scss";

interface ICounterAuthorProps {
    login: string;
    className?: string;
}

interface ICounterAuthorName {
    login: string;
    language: string;
    name: string;
}

export const CounterAuthor: React.FC<ICounterAuthorProps> = ({ login, className }) => {
    const t = useComponentsTranslations();
    const { i18n: { language } } = useTranslation();
    const [author, setAuthor] = useState<ICounterAuthorName>();

    useEffect(() => {
        let active = true;
        setAuthor(undefined);

        getUserByLogin(login, language).then(response => {
            const user = response?.people?.result?.find(person => person.login === login);
            if (active) {
                const name = user?.name?.first && user.name.last ? `${user.name.first} ${user.name.last}` : login;
                setAuthor({ login, language, name });
            }
        }).catch(() => {
            if (active) {
                setAuthor({ login, language, name: login });
            }
        });

        return () => { active = false; };
    }, [login, language]);

    const name = author?.login === login && author.language === language ? author.name : undefined;

    if (!name) {
        return <div role="status" aria-label={t("autonumber.counterAuthorLoading")}>
            <LinearProgress className={styles.loading}/>
        </div>;
    }

    return <div className={className}>
        {t("autonumber.counterNameHint")}{"\u00a0"}
        <span>
            {t("autonumber.counterAuthor")}{" "}
            <a className={styles.link} href={`https://staff.yandex-team.ru/${encodeURIComponent(login)}`}
               target="_blank" rel="noopener noreferrer">{name}</a>
        </span>
    </div>;
};
